import React from 'react';
import './Hero.css';

const JSON_LINES = [
  { key: null,       val: '{',                          type: 'bracket' },
  { key: 'name',     val: '"Shahd Abubaker"',           type: 'str' },
  { key: 'role',     val: '"Site Reliability Engineer"', type: 'str' },
  { key: 'company',  val: '"SITA"',                     type: 'str' },
  { key: 'location', val: '"Amman, Jordan"',             type: 'str' },
  { key: 'experience_yrs', val: '10',                   type: 'num' },
  { key: 'clouds',   val: '["AWS", "Azure", "GCP"]',    type: 'arr' },
  { key: 'community',val: '"CNCF Jordan Chapter Organizer"', type: 'str' },
  { key: 'open_to',  val: '"consulting"',               type: 'str' },
  { key: 'status',   val: 'operational',                type: 'green' },
  { key: null,       val: '}',                          type: 'bracket' },
];

export default function Hero() {
  return (
    <section id="work" className="hero">
      <div className="hero-terminal">
        <div className="json-titlebar">
          <span className="json-filename">whoami.json</span>
        </div>
        <div className="json-body">
          {JSON_LINES.map((l, i) => (
            <div key={i} className="json-line">
              {l.key && (
                <>
                  <span className="indent" />
                  <span className="json-key">"{l.key}"</span>
                  <span className="json-colon">: </span>
                </>
              )}
              <span className={`json-val ${l.type}`}>{l.val}</span>
              {l.key && i < JSON_LINES.length - 1 && <span className="json-comma">,</span>}
            </div>
          ))}
          <span className="cursor" />
        </div>
      </div>

      <div className="hero-id">
        <div className="hero-id-inner">
          <div className="hero-status">
            <span className="status-dot" />
            <span className="status-text">open to consulting</span>
          </div>
          <h1 className="hero-name">
            Shahd<br /><em>Abubaker</em>
          </h1>
          <div className="hero-role">SRE at SITA · Amman, Jordan</div>
          <p className="hero-desc">
            I keep critical infrastructure running at a scale most engineers never touch.
            Airports, airlines, border control — systems that cannot go down.
            Ten years of building platforms that hold under real pressure.
          </p>
        </div>
        <div className="hero-btns">
          <a href="#consulting" className="btn-green">./view-work.sh</a>
          <a href="#contact" className="btn-ghost">./contact.sh</a>
        </div>
      </div>
    </section>
  );
}
